import { useQuery } from 'react-query';
import { format } from 'date-fns';
import { getWithdrawRequests, IWithdrawRequestsParams } from '../api/withdraw';
import { useState } from 'react';
import { TSelectableWithdrawRequest } from '../types/IWithdrawRequest';
import { DATE_FORMAT } from '../constants';

interface ISelectableWithdrawRequestsResponse {
    total: number;
    entities: TSelectableWithdrawRequest[];
}

interface ISelectableResponse {
    withdrawRequestsData: ISelectableWithdrawRequestsResponse;
    isLoading: boolean;
    onSelect: (id: string) => void;
    selectAll: () => void;
    refetch: () => void;
}

export function useGetWithdrawRequests(params: IWithdrawRequestsParams): ISelectableResponse {
    const [selected, setSelected] = useState<string[]>([]);

    const {
        data: withdrawRequestsData,
        isLoading,
        refetch,
    } = useQuery(
        [
            'withdrawRequests',
            params.searchQuery,
            params.pageNumber,
            params.pageSize,
            params.statuses,
            params.createdFrom,
            params.createdTo,
            params.isVerified,
        ],
        () => getWithdrawRequests(params),
        {
            retry: false,
            staleTime: Infinity,
            cacheTime: 100,
        }
    );

    const onSelect = (id: string) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((selectedElement) => selectedElement !== id));
        } else {
            setSelected(selected.concat(id));
        }
    };

    const selectAll = () => {
        if (selected.length === withdrawRequestsData?.entities.length) {
            setSelected([]);
        } else {
            setSelected(withdrawRequestsData?.entities.map((request) => request.id) ?? []);
        }
    };

    return {
        withdrawRequestsData: {
            entities:
                (withdrawRequestsData &&
                    withdrawRequestsData.entities &&
                    withdrawRequestsData.entities.map((entity) => ({
                        ...entity,
                        createdAt: format(new Date(entity.createdAt), DATE_FORMAT),
                        isSelected: selected.includes(entity.id),
                    }))) ||
                [],
            total: withdrawRequestsData?.total || 0,
        },
        isLoading,
        onSelect,
        selectAll,
        refetch,
    };
}
